import { useState, useCallback } from 'react';
import { omit } from 'lodash';
import {
  ILandingPageBuilderForm,
  ILandingPageBuilderPayload,
  ILpCustomer,
  ILpReseller,
} from '../types';
import { useGenerateAssets } from './useGenerateAssets';
import { buildImageField } from '../components/modal/LandingPageBuilderModal';

export const usePrepareLandingPageData = () => {
  const { generateAssets, isGeneratingAssets } = useGenerateAssets();

  const [isPreparing, setIsPreparing] = useState(false);

  const prepare = useCallback(async (values: ILandingPageBuilderForm) => {
    setIsPreparing(true);

    const { bodyBackgroundImage, headerLogo } = values;

    const resellers: ILpReseller[] = [];
    const customers: ILpCustomer[] = [];

    Object.keys(values.access).forEach((resellerKeyId: string) => {
      const resellerId = Number(resellerKeyId);

      if (values.access[resellerId].isResellerSelected) {
        resellers.push({ resellerId });
      } else {
        const selectedCustomers = values.access[resellerId].selectedCustomers;
        Object.keys(selectedCustomers).forEach((customerKeyId: string) => {
          const customerId = Number(customerKeyId);
          customers.push({
            customerId,
            default: selectedCustomers[customerId].default,
          });
        });
      }
    });

    const { bodyImageUrl, headerLogoUrl } = await generateAssets({
      bodyBackgroundImage,
      headerLogo,
    });

    const requestValues = omit(values, [
      'access',
      'uiKits',
      'selectedResellerId',
    ]);

    setIsPreparing(false);

    const data: ILandingPageBuilderPayload = {
      ...requestValues,
      title:
        requestValues.title ||
        `landing-page-design-${new Date().toISOString()}`,
      bodyBackgroundImage: buildImageField(
        bodyBackgroundImage?.file,
        bodyImageUrl
      )?.url,
      headerLogo: buildImageField(headerLogo?.file, headerLogoUrl)?.url,
      customers,
      resellers,
    };
    return data;
  }, []);

  return { prepare, isPreparing, isGeneratingAssets };
};
